<div class="fluid grid">

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="cliComLabel"
                         [parentCompany]="0"
                         [disabled]="true"
                         [selectedID]="newDocument.DOCCLIENTSID"
                         (selectedCompanyID)="cliCompanySelected($event)"></app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="cliPerLabel" [parentCompany]="newDocument.DOCCLIENTSID" [disabled]="!newDocument.DOCCLIENTSID"
                        [selectedID]="newDocument.DOCPERSONID" (selectedPersonID)="cliPersonSelected($event)"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector [labelKey]="manDepLabel"
                            [disabled]="true"
                            [parentCompany]="newDocument.DOCCLIENTSID"
                            [selectedID]="newDocument.DOCCLIDEPID"
                            (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-companyselector [labelKey]="pcoComLabel"
                         [disabled]="true"
                         [parentCompany]="newDocument.DOCCLIENTSID"
                         [selectedID]="newDocument.DOCPCOCLIID"
                         (selectedCompanyID)="pcoCompanySelected($event)"></app-companyselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12">
    <app-personselector [labelKey]="pcoPerLabel"
                        [parentCompany]="newDocument.DOCPCOCLIID"
                        [disabled]="true"
                        [selectedID]="newDocument.DOCPCOPERID"
                        (selectedPersonID)="pcoPersonSelected($event)"></app-personselector>
  </div>

  <div class="col-4 xl:col-4 sm:col-12" *ngIf="selectDepartmentOn">
    <app-departmentselector [labelKey]="pcoDepLabel"
                            [disabled]="true"
                            [parentCompany]="newDocument.DOCPCOCLIID"
                            [selectedID]="newDocument.DOCPCODEPID"
                            (selectedDepartmentID)="pcoStockSelected($event)"></app-departmentselector>
  </div>

</div>
